export type BrandKey = "avanti" | "staysure";

export type DomainKey = "STS" | "AVN" | "EXP";

export const fontVerisk: Record<
  BrandKey,
  { primaryFont: string; secondoryFont: string }
> = {
  avanti: {
    primaryFont: '"faktum", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"faktum", "sans-serif"',
  },
  staysure: {
    primaryFont: '"proxima-nova", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"DM Serif Display", "sans-serif"',
  },
};

export const styleVerisk: Record<
  DomainKey,
  { stylesheet: string; herf: string; id: string }
> = {
  AVN: {
    stylesheet: "stylesheet",
    herf: "/avanti.css",
    id: "brand-stylesheet-avanti",
  },
  STS: {
    stylesheet: "stylesheet",
    herf: "/staysure.css",
    id: "brand-stylesheet-staysure",
  },
  EXP: {
    stylesheet: "stylesheet",
    herf: "/staysure.css",
    id: "brand-stylesheet-staysure",
  },
};

export const brandVerisk: Record<BrandKey, { v3: string; domain: string }> = {
  avanti: {
    v3: "avt",
    domain: "AVN",
  },
  staysure: {
    v3: "sts",
    domain: "STS",
  },
};

export const domainVerisk: Record<DomainKey, { v3: string; brand: string }> = {
  AVN: {
    v3: "avt",
    brand: "avanti",
  },
  STS: {
    v3: "sts",
    brand: "staysure",
  },
  EXP: {
    v3: "sts",
    brand: "staysure",
  },
};

export const domainHeaderVerisk: Record<
  DomainKey,
  { title: string; description: string; favicon: string }
> = {
  AVN: {
    title: "Avanti™ Travel Insurance – Get the best cover for your holiday",
    description:
      "Want Single, Annual Or Cruise Travel Insurance? Medical Conditions Covered. Unlimited Medical Expenses Option. Get A Quote Today!",
    favicon: "/avanti.ico",
  },
  STS: {
    title: "Staysure™ Travel Insurance - It's Worth Doing Right",
    description:
      "Staysure is the over 50s expert, offering a wide range of products and services including travel insurance, private medical, life insurance, and more.",
    favicon: "/favicon.ico",
  },
  EXP: {
    title: "Staysure Expat™ Travel Insurance – Holiday Insurance for UK Expats",
    description:
      "EXPAT is the over 50s expert, offering a wide range of products and services including travel insurance, private medical, life insurance and more.",
    favicon: "/favicon.ico",
  },
};

export function checkGetHelpButtonStatus(
  domain: string,
  business: string,
  operationFlow: string
) {
  let isHelpButton = true;

  if (operationFlow === "MTA_FLOW" && business === "OFFLINE") {
    isHelpButton = false;
  } else if (domain === "EXP" && business === "OFFLINE") {
    isHelpButton = true;
  } else if (domain === "EXP" && business === "ONLINE") {
    isHelpButton = false;
  }

  return isHelpButton;
}
